import * as React from 'react';

import { DataTable, Table } from '../../components/common';
import Utils from '../../common/utils';
import { IconButton } from '../../components/buttons';
import { IconEdit } from '../../components/icons';

interface Props {
	history: any;
	answers: PolicyAnswerWithDeclineInfoDto;
	isLoading: boolean;
	questions: { [name: string]: string; }[];
	onRowClick: (e: any, answerId?: string) => void;
	allowFormat: boolean;
}

interface TravelAnswer {
	abroadLocation: string;
	abroadDuration: string;
}

class CustomerPolicyAnswersDetails extends React.Component<Props> {
	render() {
		const { ...props } = this.props;
		return(
			<div className="content-set">
				<DataTable
					TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
					columns={[
						{
							Header: 'Question',
							accessor: 'questionValue',
							Cell: (rowInfo: any) => {
								return this.questionTextFormatter(rowInfo.original.categoryId, rowInfo.original.subCategoryId, rowInfo.value);
							}
						},
						{
							Header: 'Answer',
							accessor: 'answer',
							Cell: (rowInfo: any) => {
								return props.allowFormat ? this.answerFormatter(rowInfo.original.questionName, rowInfo.original.answer) : rowInfo.value;
							}
						},
						{
							Header: 'Notes',
							accessor: 'id',
							className: 'p-0 td-actions',
							width: 100,
							Cell: (rowInfo: any) => {
								return (Utils.verifyAnswerHasNotes(rowInfo.value) &&
									(
									<IconButton
										title="Edit note"
										className="btn-icon-secondary btn-icon-td"
									>
									<IconEdit/>
									</IconButton>
									)
								);
							}
						}
					]}
					data={props.answers.answerList}
					loading={props.isLoading}
					getTrProps={(state: any, rowInfo: any, column: any) => {
						if (rowInfo && rowInfo.row) {
							return {
								className: rowInfo.original.isDeclined ? 'tr interactive border border-danger' : 'tr interactive',
								onClick: (e: any) => props.onRowClick(e, rowInfo.original.id)
							};
						} else {
							return {
								className: 'tr interactive',
								onClick: (e: any) => props.onRowClick(e, rowInfo.original.id)
							};
						}
					}}
					noDataText="No answers found"
					defaultPageSize={100}
				/>
			</div>
		);
	}

	private questionTextFormatter = (categoryId: number, subCategoryId: number, questionText: string) => {
		if (categoryId !== 12) {
			return categoryId + '.' + subCategoryId + ' ' + questionText;
		} else {
			switch (subCategoryId) {
				case 1:
					return categoryId + '.' + subCategoryId + ' History of cancer';
				case 2:
					return categoryId + '.' + subCategoryId + ' History of heart and circulatory system disorders';
				case 3:
					return categoryId + '.' + subCategoryId + ' History of neurological disorders';
				case 4:
					return categoryId + '.' + subCategoryId + ' History of respiratory Disorders';
				case 5:
					return categoryId + '.' + subCategoryId + ' History of liver, stomach, bladder, kidney, or gastrointestinal disorders';
				case 6:
					return categoryId + '.' + subCategoryId + ' History of blood, glandular or endocrine system disorders';
				case 7:
					return categoryId + '.' + subCategoryId + ' History of immunological disorders';
				case 8:
					return categoryId + '.' + subCategoryId + ' History of head injury or musculoskeletal system disorders';
				case 9:
					return categoryId + '.' + subCategoryId + ' History of reproductive system disorders';
				case 13:
					return categoryId + '.' + subCategoryId + ' History of psychological Disorders';
				default:
					return categoryId + '.' + subCategoryId + ' ' + questionText;
			}
		}
	}

	private answerFormatter = (questionName: string, answer: any) => {
		switch (questionName) {
			case 'activities':
			case 'abroad':
			case 'ownPetsTypes':
			case 'cancer':
			case 'heartCirculatory':
			case 'neurological':
			case 'respiratory':
			case 'liver':
			case 'blood':
			case 'immuno':
			case 'head':
			case 'reproductive':
			case 'psychological':
			case 'favoriteActivities':
				return this.formatObjectAnswer(answer, questionName);
				case 'specificJob':
				switch (answer) {
					case 'offshoreFisher':
						return 'Offshore commercial fisher not coming ashore daily';
					case 'steelErector':
						return 'Steel erector or scaffolder working at heights over 40 feet</dd>';
					case 'fallerOrLumberjack':
						return 'Faller or lumberjack';
					case 'offshoreDriller':
						return 'Offshore driller';
					case 'blaster':
						return 'Blaster or explosive handler';
					case 'occupationNoneOfTheAbove':
						return 'None of listing selections';
					default:
						return;
				}
			case 'reasonForUnemployment':
				switch (answer) {
					case 'parent':
						return 'Parent or caregiver';
					case 'disabledOrMedicalLeave':
						return 'On disability or medical leave';
					case 'socialAssistance':
						return 'Social assistance';
					case 'cannotFindWork':
						return 'Cannot find work';
					case 'retired':
						return 'Retired';
					case 'other':
						return 'Other reason';
					default:
						return;
				}
			case 'exerciseFrequentlyHours':
				switch (answer) {
					case '0':
						return 'I rarely excercise';
					case '0-1':
						return 'Less than 1 hour';
					case '1-2':
						return '1-2 hours';
					case '2-3':
						return '2-3 hours';
					case '3-4':
						return '3-4 hours';
					case '4-5':
						return '4-5 hours';
					case '5-6':
						return '5-6 hours';
					case '6-7':
						return '6-7 hours';
					case '7+':
						return 'More than 7 hours';
					default:
						return;
				}
			case 'usedTobaccoLastUsed':
				switch (answer) {
					case 'withinThePastMonth':
						return 'Within the past month';
					case 'withinThePast6Months':
						return '1-6 months ago';
					case 'withinThePast12Months':
						return '6-12 months ago';
					case 'withinThePast24Months':
						return '12-24 months ago';
					default:
						return;
				}
			default:
				return this.formatPlainTextAnswer(answer, questionName);
		}
	}

	private formatPlainTextAnswer = (answer: any, questionName: string) => {
		if (questionName === 'consumedAlcohol' && answer !== 'false') {
			return answer;
		}
		if (typeof answer === 'string') {
			const splitExpression = new RegExp('(^|\s)(?=[A-Z])');
			const formattedAnswer = answer.split(splitExpression).join(' ');
			return formattedAnswer.charAt(0).toUpperCase() + formattedAnswer.slice(1);
		}
		return answer;
	}

	// Note that formatObjectAnswer here is different from the one in PolicyAnswerModal,
	// since the answerValue passed from table row is ALWAYS string type
	private formatObjectAnswer = (answer: string, questionName: string) => {
		const answerObj = JSON.parse(answer);
		let answerString = '';
		switch (questionName) {
			case 'favoriteActivities':
				answerObj.forEach((item: string) => {
					answerString += item + ';';
				});
				break;
			case 'abroad':
				if (answer === 'false') {
					answerString = 'None';
				} else {
					answerObj.forEach((subObject: TravelAnswer) => {
						answerString += subObject.abroadLocation + ': ' + this.formatAbroadDuration(subObject.abroadDuration);
					});
				}
				break;
			default:
				(Object.keys(answerObj)).forEach((key: string) => {
					if (key.includes('isValid')) {
						return;
					} else if (key.includes('None')) {
						if (answerObj[key] === true ) {
							answerString = 'None';
							return;
						}
					} else {
						if (answerObj[key] === false) {
							return;
						}
						answerString += this.getQuestionTextByName(key, answerObj[key], answerObj) + ''
							+ ((typeof(answerObj[key]) !== 'boolean' && !this.isMedicalOtherDetails(key)) ? answerObj[key] : '') + 
							(!this.isMedicalOtherDetails(key) ? ';' : '');
					}
				});
				break;
		}
		if (answerString[answerString.length - 1] === ';') {
			answerString = answerString.substring(0, answerString.length - 1);
		}
		return answerString;
	}

	private formatAbroadDuration = (abroadDuration: string) => {
		switch (abroadDuration) {
			case '0-4':
				return 'Less than 4 weeks;';
			case '4-12':
				return '4-12 weeks;';
			case '13-26':
				return '13-26 weeks;';
			case '26+':
				return 'More than 26 weeks;';
			default:
				return;
		}
	}

	private isMedicalOtherDetails = (questionName: string) => {
		if (questionName === 'cancerOtherDetails' || questionName === 'heartDisorderOtherDetails' ||
			questionName === 'neurologicalDisorderOtherDetails' || questionName === 'respiratoryDisorderOtherDetails' ||
			questionName === 'gastrointestinalDisorderOtherDetails' || questionName === 'endocrineDisorderOtherDetails' ||
			questionName === 'immuneSystemDisorderOtherDetails' || questionName === 'musculoskeletalDisorderOtherDetails' ||
			questionName === 'reproductiveDisorderOtherDetails' || questionName === 'psychologicalDisorderOtherDetails') {
			return true;
		}
		return false;
	}

	private getQuestionTextByName = (questionName: string, answerValue: any, answerObject: any) => {
		var regex = /<.*?>/gi;
		let otherDetails = '';
		// the cancer one is actually a bug, better to fix it when we decide to change the way how we save answer into DB
		if (this.props.questions[questionName] === undefined || questionName === 'cancer') {
			// handle all hard-coded question text here
			switch (questionName) {
				// aviation
				case 'heliSkiSnowboarding':
					return 'Heli-skiing or snowboarding';
				case 'outOfBoundsSkiingSnowboarding':
					return 'Out-of-bounds or backcountry skiing or snowboarding';
				case 'backCountrySnowMobiling':
					return 'Backcountry snowmobiling';
				case 'skydiving':
					return 'Skydiving';
				case 'wingsuitFlying':
					return 'Wingsuit flying';
				case 'parachuting':
					return 'Parachuting';
				case 'skysurfing':
					return 'Skysurfing';
				case 'canopyPiloting':
					return 'Canopy piloting';
				// pets
				case 'dogs':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					return 'Dog(s)';
				case 'cats':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					return 'Cat(s)';
				case 'others':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					return 'Other(s)';														
				// cancer
				case 'cancer':
					return 'Any cancer or tumor except for basal cell carcinoma';
				case 'tumor':
					return 'Any tumor or growth not yet diagnosed';
				case 'dysplasticNeviSyndrome':
					return 'Dysplastic nevi syndrome';
				case 'cancerOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'cancerOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// heart & circulatory
				case 'elevatedCholesterol':
					return 'Elevated cholesterol or high blood pressure uncontrolled within the past 12 months';
				case 'chestPain':
					return 'Chest pain or angina';
				case 'shortnessOfBreath':
					return 'Shortness of breath';
				case 'heartAttack':
					return 'Heart attack (myocardial infarction)';
				case 'coronaryArteryDisease':
					return 'Coronary artery disease or carotid artery disease';
				case 'aneurysm':
					return 'Aneurysm';
				case 'valvularHeartDisease':
					return 'Valvular heart disease (e.g., mitral valve prolapse)';
				case 'cardiomyopathy':
					return 'Cardiomyopathy';
				case 'congestiveHeartFailure':
					return 'Congestive heart failure';
				case 'bypassOrAngioplasty':
					return 'Bypass surgery or angioplasty';
				case 'abnormalECG':
					return 'Abnormal ECG, cardiac stress test, or echocardiogram';
				case 'irregularPulse':
					return 'Irregular pulse';
				case 'heartMurmur':
					return 'Heart murmur';
				case 'pacemaker':
					return 'Pacemaker';
				case 'peripheralVascularDisease':
					return 'Peripheral vascular disease';
				case 'bloodClot':
					return 'Blood clot, embolism or clotting disorder';
				case 'heartDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'heartDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// neurological
				case 'epilepsy':
					return 'Epilepsy or seizures with any episodes within the past 12 months';
				case 'tremor':
					return 'Tremor';
				case 'huntingtonsDisease':
					return `Huntington's disease`;
				case 'brainAneurysm':
					return 'Brain aneurysm';
				case 'tia':
					return 'Transient ischemic attack (TIA)';
				case 'stroke':
					return 'Stroke';
				case 'parkinsonsDisease':
					return `Parkinson's disease`;
				case 'als':
					return `Motor neuron disease (Lou Gehrig's disease or ALS)`;
				case 'alzheimersDisease':
					return `Alzheimer's disease`;
				case 'cognitiveImpairment':
					return 'Cognitive impairment';
				case 'dementia':
					return 'Dementia';
				case 'multipleSclerosis':
					return 'Multiple sclerosis';
				case 'muscularDystrophy':
					return 'Muscular dystrophy';
				case 'lossOfBalance':
					return 'Loss of balance';
				case 'lossOfSpeech':
					return 'Loss of speech';
				case 'cerebralPalsy':
					return 'Cerebral palsy';
				case 'downSyndrome':
					return 'Down syndrome';
				case 'autism':
					return 'Autism';
				case 'developmentalDisorder':
					return 'Developmental disorder';
				case 'muscleWeakness':
					return 'Muscle weakness, tingling, or numbness of the extremities';
				case 'neurologicalDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'neurologicalDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// respiratory
				case 'sleepApnea':
					return 'Sleep apnea for which you are not treated';
				case 'emphysema':
					return 'Emphysema';
				case 'tuberculosis':
					return 'Tuberculosis';
				case 'sarcoidosis':
					return 'Sarcoidosis';
				case 'cysticFibrosis':
					return 'Cystic fibrosis';
				case 'asthma':
					return `Asthma requiring either a visit to the emergency room
					or the administration of oxygen within the past 12 months`;
				case 'copd':
					return 'Chronic obstructive pulmonary disease (COPD)';
				case 'respiratoryDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'respiratoryDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// liver
				case 'hepatitisBorC':
					return 'Hepatitis B or C';
				case 'cirrhosis':
					return 'Cirrhosis';
				case 'sclerosingCholangitis':
					return 'Sclerosing cholangitis';
				case 'crohnsDisease':
					return `Crohn’s disease or ulcerative colitis with any flare-up within
					the past 5 years or any continued use of oral steroid`;
				case 'bleedingRectum':
					return 'Rectal bleeding other than diagnosed as hemorrhoids';
				case 'pancreatitis':
					return 'Pancreatitis';
				case 'chronicKidneyDisease':
					return 'Chronic kidney disease or nephritis';
				case 'bloodInUrine':
					return 'Blood or protein in urine';
				case 'gastrointestinalDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'gastrointestinalDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// blood
				case 'diabetes':
					return 'Diabetes';
				case 'goiter':
					return 'Goiter or thyroid disorder other than hypothyroidism';
				case 'anemia':
					return 'Anemia';
				case 'bleedingDisorder':
					return 'Bleeding disorder';
				case 'hemophilia':
					return 'Hemophilia';
				case 'sicklecell':
					return 'Sickle cell anemia';
				case 'thalassemia':
					return 'Thalassemia';
				case 'endocrineDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'endocrineDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// immuno
				case 'aids':
					return 'Acquired immune deficiency syndrome (AIDS)';
				case 'arc':
					return 'AIDS related complex (ARC)';
				case 'hiv':
					return 'Human immunodeficiency virus (HIV)';
				case 'immuneSystemDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'immuneSystemDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// head
				case 'brainInjury':
					return 'Traumatic brain injury or post-concussion syndrome with ongoing symptoms';
				case 'rheumatoidArthritis':
					return 'Rheumatoid arthritis';
				case 'ankylosingSpondylitis':
					return 'Ankylosing spondylitis';
				case 'connectiveTissueDisease':
					return 'Connective tissue disease';
				case 'lupus':
					return 'Lupus';
				case 'paralysis':
					return 'Paralysis';
				case 'musculoskeletalDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'musculoskeletalDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// reproductive
				case 'abnormalMammogram':
					return 'Abnormal mammogram or breast imaging';
				case 'breastImagingTestOrPAPTest':
					return 'Abnormal PAP test';
				case 'abnormalPSATest':
					return 'Abnormal prostate (PSA) test';
				case 'abnormalBiopsy':
					return 'Abnormal biopsy';
				case 'reproductiveDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'reproductiveDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// psychological
				case 'bipolarDisease':
					return 'Bipolar disease';
				case 'psychosis':
					return 'Psychosis or any psychotic episode';
				case 'contemplatedSuicide':
					return 'Any contemplated or attempted suicide';
				case 'psychologicalDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'psychologicalDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				default:
					return ''; // needs to return empty string here otherwise it shows undefined in table row
			}
		}
		return this.props.questions[questionName].replace(regex, '');
	}

}

export default CustomerPolicyAnswersDetails;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/CustomerPolicyAnswersDetails.tsx